import { getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Get the dashboard data for an entity.
 * @param {string} entityId - The entity ID.
 */
export const getDashboard = async (entityId) => {
  try {
    return await axios.get(`/entities/${entityId}/dashboard/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Dismiss the welcome message permanently.
 * @param {string} entityId - The entity ID.
 */
export const dismissWelcome = async (entityId) => {
  try {
    return await axios.post(`/entities/${entityId}/dashboard/dismiss-welcome/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
